import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFetchBaseQuery } from "@/redux/apiFetchBaseQuery";

export const agencyFileManagerSlice = createApi({
	reducerPath: "agencyFileManagerSlice",
	baseQuery: apiFetchBaseQuery,
	tagTypes: ["user"],
	endpoints: builder => ({
		getDocStorage: builder.query({
			query: ({ agencyId, order_id, start_date, end_date, search, category, page_no = "1", limit = "10" }) => {
				const params = new URLSearchParams();

				if (order_id) params.append("order_id", order_id);
				if (start_date) params.append("start_date", start_date);
				if (end_date) params.append("end_date", end_date);
				if (search) params.append("search", search);
				if (category) params.append("category", category);

				params.append("page_no", page_no);
				params.append("limit", limit);

				return {
					url: `/doc-storage/agency/${agencyId}/assets?${params.toString()}`,
				};
			},
		}),
	}),
});

export const { useGetDocStorageQuery } = agencyFileManagerSlice;
